import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  CircularProgress,
  Divider,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAuth } from '../../Contexts/AuthContext';
import { getFaq } from '../../Helpers/helpApi';
import FeedbackWidget from './FeedbackWidget';

export default function FAQView() {
  const auth = useAuth();
  const [grouped, setGrouped] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getFaq(auth.activeUser?.accessToken)
      .then((response) => {
        if (response?.data && typeof response.data === 'object') {
          setGrouped(response.data);
        } else {
          setGrouped({});
        }
      })
      .catch(() => setError('Failed to load FAQ.'))
      .finally(() => setLoading(false));
  }, [auth.activeUser?.accessToken]);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
  if (error) return <Box sx={{ p: 2 }}><Alert severity="error">{error}</Alert></Box>;

  const categories = Object.keys(grouped);

  if (categories.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">No FAQ entries available yet.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Frequently Asked Questions</Typography>
      {categories.map((category) => (
        <Box key={category} sx={{ mb: 3 }}>
          <Typography variant="overline" color="text.secondary" display="block" sx={{ mb: 1 }}>
            {category}
          </Typography>
          {grouped[category].map((entry) => (
            <Accordion key={entry.id} disableGutters elevation={0} sx={{ border: 1, borderColor: 'divider', mb: 0.5, '&:before': { display: 'none' } }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="body2" fontWeight={500}>{entry.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{entry.answer}</Typography>
                <FeedbackWidget contentId={entry.id} contentType="faq" />
              </AccordionDetails>
            </Accordion>
          ))}
          <Divider sx={{ mt: 2, mb: 1 }} />
          <Typography
            variant="caption"
            color="primary"
            component="a"
            href="mailto:support@bridgefirstforecasting.com"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            Contact Support
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
